export default {
  url: "https://scusesoapp01dev.bunzlusa.com:2020/api/v1", // This is for DEV,
  proxyUrl: "https://callservicelayer.azurewebsites.net/api/callEssApi?url=", // This is for Proxy server
  proxyUrlForDownload: "https://callservicelayer.azurewebsites.net/api/download?url=", // This is for Proxy server
  proxyUrlPost: "https://callservicelayer.azurewebsites.net/api/callEssApiPost?url=", 
  proxyPost:"https://callservicelayer.azurewebsites.net/api/loginEssPostApi",

  // url: "http://localhost:44348/api/v1",
  // proxyUrl: "http://localhost:44302/api/callEssApi?url=", // This is for Proxy server
  // proxyUrlForDownload: "http://localhost:44302/api/download?url=", // This is for Proxy server
  // proxyUrlPost: "http://localhost:44302/api/callEssApiPost?url=",
  // proxyPost: "http://localhost:44302/api/loginEssPostApi"
};

